import {Component, Input} from '@angular/core';

/**
 * Generated class for the SellionsAdvantageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sellions-advantage',
  templateUrl: 'sellions-advantage.html'
})
export class SellionsAdvantageComponent {
    @Input() advantageValue;
    @Input() advantageTitle;
    @Input() advantageName;
    @Input() advantageIcon;
    @Input() advantageMessage;


  constructor() {}

}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-advantage/sellions-advantage.ts